<template>
  <div v-click-outside="outside">
    <div class="relative">
      <div
        class="absolute w-10 right-0 top-0 bottom-0 text-beige-400 text-2xl text-center pt-2.5 cursor-pointer"
        @click="showCalendar"
      >
      <img src="/dist/icons/calendar.svg" class="style-icon" alt="calendar">
      </div>
      <input
        type="text"
        :placeholder="placeholder ?? '04-2007'"
        v-mask="'##-####'"
        v-model="inputDate"
        :class="{ error: error }"
        @focus="setFocus(true)"
        @blur="setFocus(false)"
      />
    </div>
    <div class="relative z-50">
      <div
        v-if="calendarVisible"
        class="absolute bg-white w-[20rem] p-2.5 border border-beige-400 rounded-sm top-auto bottom-16"
      >
        <div class="flex flex-wrap mt-4 mb-5">
          <button class="cursor-pointer basis-1/5" @click="yearBack()">
            <span
              class="inline-block font-bold p-1.5 rounded-sm hover:bg-red-400 hover:text-white"
              >&lt;&lt;</span
            >
          </button>
          <div class="text-base font-bold text-center basis-3/5">
            {{ pickedYear }}
          </div>
          <button class="cursor-pointer basis-1/5" @click="yearForward()">
            <span
              class="inline-block font-bold p-1.5 rounded-sm hover:bg-red-400 hover:text-white"
              >&gt;&gt;</span
            >
          </button>
        </div>

        <div class="">
          <ul class="grid grid-cols-3 gap-1.5 text-2xs">
            <li
              v-for="(item, index) in months"
              :key="index"
              class="text-center rounded-sm bg-beige-400 cursor-pointer py-1.5 px-2.5 hover:bg-red-400 hover:text-white"
              :class="{
                'bg-red-400 text-white': item.value == pickedMonth,
                'border border-grey-500': item.selected
              }"
              @click="setDate(item.value, true)"
            >
              {{ english == true ? item.english : item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
module.exports = {
  name: 'MonthPicker',
  props: ['month', 'year', 'english', 'placeholder'],
  created () {
    var d = new Date()
    this.pickedYear = d.getFullYear()

    if (this.month !== null && this.year !== null) {
      this.pickedMonth = this.month
      this.pickedYear = this.year

      this.setDate()
    }

    window.addEventListener('keydown', e => {
      if (this.calendarVisible) {
        if (e.key == 'Enter') {
          var $this = this

          var selectedMonth = this.months.find(
            x => x.value == $this.pickedMonth
          )

          if (selectedMonth) {
            this.pickedMonth = selectedMonth.value
            this.setDate()
            this.hideCalendar()
          }
        }

        if (e.key == 'Escape') {
          this.hideCalendar()
        }

        if (e.key == 'ArrowDown') {
          var $this = this
          var itemIndex = null

          var selectedMonth = this.months.find(function (item, index) {
            if (item.value == $this.pickedMonth) {
              itemIndex = index
              return item
            }
          })

          if (itemIndex == null) {
            this.pickedMonth = this.months[0].value
            this.setDate()
            return
          }

          if (itemIndex + 1 == this.months.length) {
            this.pickedMonth = this.months[0].value
            this.setDate()
            return
          }

          this.pickedMonth = this.months[itemIndex + 1].value
          this.setDate()
        }

        if (e.key == 'ArrowUp') {
          var $this = this
          var itemIndex = null

          var selectedMonth = this.months.find(function (item, index) {
            if (item.value == $this.pickedMonth) {
              itemIndex = index
              return item
            }
          })

          if (itemIndex == null) {
            this.pickedMonth = this.months[0].value
            this.setDate()
            return
          }

          if (itemIndex == 0) {
            this.pickedMonth = this.months[this.months.length - 1].value
            this.setDate()
            return
          }

          this.pickedMonth = this.months[itemIndex - 1].value
          this.setDate()
        }

        if (e.key == 'ArrowLeft') {
          this.yearBack()
        }

        if (e.key == 'ArrowRight') {
          this.yearForward()
        }
      } else {
        if (this.inputFocus == true) {
          if (e.key == 'Enter') {
            this.showCalendar()
          }
          if (e.key == 'ArrowDown') {
            this.showCalendar()
          }
        }
      }
    })
  },
  data: function () {
    return {
      calendarVisible: false,
      date: null,
      inputDate: null,
      inputFocus: false,
      error: false,
      pickedMonth: null,
      pickedYear: null,
      months: [
        { name: 'Januar', english: 'January', value: '01', selected: false },
        { name: 'Februar', english: 'February', value: '02', selected: false },
        { name: 'Marts', english: 'March', value: '03', selected: false },
        { name: 'April', english: 'April', value: '04', selected: false },
        { name: 'Maj', english: 'May', value: '05', selected: false },
        { name: 'Juni', english: 'June', value: '06', selected: false },
        { name: 'Juli', english: 'July', value: '07', selected: false },
        { name: 'August', english: 'August', value: '08', selected: false },
        {
          name: 'September',
          english: 'September',
          value: '09',
          selected: false
        },
        { name: 'Oktober', english: 'October', value: '10', selected: false },
        { name: 'November', english: 'November', value: '11', selected: false },
        { name: 'December', english: 'December', value: '12', selected: false }
      ]
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) {
            warn += `Found in component '${compName}'`
          }

          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },
  watch: {
    inputDate: {
      handler: function (newValue) {
        this.error = false
        if (newValue.length == 7) {
          this.error = false

          var dateArr = newValue.split('-')

          var isValidMonth = dateArr[0].match(/(0[1-9]|1[012])/)

          if (isValidMonth == null) {
            this.error = true
            return
          }

          var month = dateArr[0]
          var fullYear = dateArr[1]

          if (Number(fullYear) < 1900 || Number(fullYear) > 2155) {
            this.error = true
            return
          }
          this.pickedMonth = month
          this.pickedYear = fullYear
          this.setDate()
        }
      }
    }
  },
  methods: {
    setFocus (focus) {
      this.inputFocus = focus

      if (focus == true) {
        this.showCalendar()
      }
    },
    outside () {
      this.hideCalendar()
    },
    showCalendar () {
      this.calendarVisible = true
    },
    hideCalendar () {
      this.calendarVisible = false
    },
    yearBack () {
      this.pickedYear--
      this.setDate()
    },
    yearForward () {
      this.pickedYear++
      this.setDate()
    },
    setDate (month = null, remove = false) {
      if (month != null) {
        this.pickedMonth = month
      }
      this.date = this.pickedMonth + '-' + this.pickedYear
      this.inputDate = this.date

      if (remove === true) {
        this.hideCalendar()
      }

      this.$emit('date-value', this.date)
    }
  }
}
</script>
